import { useMutation, useQueryClient } from '@tanstack/react-query';
import { htToast } from 'ht-styleguide';

/* Keys & Apis */
import { cart } from '@api/apis';
import { cartQueryKeys } from './queries.keys';

/* Utils */
import { Logger } from '@utils/logger';
import { ITEM_REMOVAL_TOAST_MESSAGES } from 'src/constants/cart';

interface RemovePlanParams {
  toastMessage?: (typeof ITEM_REMOVAL_TOAST_MESSAGES)[keyof typeof ITEM_REMOVAL_TOAST_MESSAGES];
}
export default function useCartMutationRemoveplan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const data = await cart.removePlan();
      if (data.status === 500) throw new Error(data.err);

      return data;
    },
    onSuccess: (data, { toastMessage = ITEM_REMOVAL_TOAST_MESSAGES.DEFAULT }: RemovePlanParams) => {
      /* Update Cart */
      const { cart: cartResponse = {} } = data?.data ?? {};
      queryClient.setQueryData(cartQueryKeys.all, { ...cartResponse });
      htToast(toastMessage);
    },
    onError: error => {
      Logger('useCartMutationRemoveplan')(error as Error);
    },
  });
}
